import React, {MouseEvent, useEffect, useMemo, useState} from "react"
import Grid from "@mui/material/Grid"
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table"
import {useAppDispatch, useAppSelector} from "../../reducers/hooks"
import {DocumentDownload, Edit, Eye, Trash} from "iconsax-react"
import Stack from "@mui/material/Stack"
import Tooltip from "@mui/material/Tooltip"
import IconButton from "@mui/material/IconButton"
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete"
import ElementModalGeneric from "sections/modals/exampleElementModal/ElementModalGeneric"
import {
    deleteElement,
    DogElement,
    getAllElement,
    getAllElementDogMuniNotPageable,
    getListDog,
    updateElementBoxDogs
} from "reducers/Dog/DogReducer"
import {Checkbox, TablePagination} from "@mui/material"
import {openSnackbar, SnackbarState} from "reducers/snackbar/snackbarReducer"
import {FormattedMessage, useIntl} from "react-intl"
import ModalChangeBox from "../../sections/modals/dog/ModalChangeBox"
import BasicTableForDog from "../../components/tables/BasicTableForDog"
import {DogElementForm} from "../../sections/forms/Dog/DogElementForm"
import store from "../../reducers/store"
import ViewDogModal from "../../components/tables/modal-historical/ViewDogModal";
import CustomLoader from "../../components/CustomLoader";
import { Document, Page, View, pdf ,Text, Image} from '@react-pdf/renderer';
import dayjs from "dayjs";


export default function Dog() {
    const dispatch = useAppDispatch()
    const intl = useIntl()

    // Stato locale
    const [open, setOpen] = useState<boolean>(false)
    const [selectedElement, setSelectedElement] = useState<DogElement | null>(null)
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<DogElement | null>(null)
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [changeBoxModalOpen, setChangeBoxModalOpen] = useState<boolean>(false)
    const [filters, setFilters] = useState<ColumnFiltersState | null>([])
    const [printData, setPrintData] = useState<DogElement[]>([])
    const [isPrinting, setIsPrinting] = useState(false)
    const [selectedRows, setSelectedRows] = useState<string[]>([])
    // view action
    const [viewModalOpen, setViewModalOpen] = useState<boolean>(false);
    const [selectedDog, setSelectedDog] = useState<string | undefined>(undefined);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const {elements, currentPage, totalRows, loading, sort} = useAppSelector((state) => state.DogElement)

    const getSortedElements = (elements: DogElement[], selectedRows: string | any[]) => {
        const selectedElements = elements.filter(el => selectedRows.includes(el._id))
        const unselectedElements = elements.filter(el => !selectedRows.includes(el._id))
        const sortedElements = [...selectedElements, ...unselectedElements]
        return sortedElements
    }

    // Recupera i dati ordinati e paginati
    const paginatedElements = getSortedElements(elements, selectedRows)

    //const sortedElements = getSortedElements(elements, selectedRows).slice(page * rowsPerPage, (currentPage + 1) * rowsPerPage)

    // Colonne della tabella
    const columns = useMemo<ColumnDef<DogElement>[]>(() => {
        return [
            {
                id: "checkbox",
                width: 30,
                cell: ({row}) => {
                    //const isChecked = selectedRows.includes(row.original._id)
                    return (
                        <Checkbox
                            checked={selectedRows.includes(row.original._id)}
                            onChange={(e) => {
                                const isSelected = e.target.checked
                                const rowId = row.original._id
                                setSelectedRows((prevSelectedRows) =>
                                    isSelected ? [...prevSelectedRows, rowId] : prevSelectedRows.filter(id => id !== rowId)
                                )
                            }}
                        />
                    )
                }
            },

            {
                header: intl.formatMessage({id: "Preview"}),
                accessorKey: 'photoProfil',
                enableColumnFilter: false,
                cell: ({row}) => {
                    const base64 = row.original.photoProfil
                    return base64 ? (
                        <img
                            src={base64}
                            alt="Preview"
                            style={{width: '100px', height: 'auto', objectFit: 'cover'}}
                        />
                    ) : (
                        <span> <FormattedMessage id="Image not available"
                                                 defaultMessage="Image not available"/></span>
                    )
                }
            },

            {
                header: intl.formatMessage({id: 'Name'}),
                accessorKey: 'name',
                cell: ({row}) => (
                    <div className="text-center">{row.original.name}</div>
                ),
                enableColumnFilter: true
            },
            {
                header: intl.formatMessage({id: 'Microchip Dog'}),
                accessorKey: 'microchipCode',
                cell: ({row}) => (
                    <div className="text-center">
            <span style={{fontSize: '16px', fontWeight: 'bold'}}>
                {row.original.microchipCode}
            </span>
                    </div>
                ),
                enableColumnFilter: true,
                minSize: 180

            },

            {
                header: intl.formatMessage({id: 'Municipality'}),
                accessorKey: 'municipalityId',
                cell: ({row}) => (
                    <div className="text-center">{row.original.municipalityId}</div>
                ),
                enableColumnFilter: true,
                minSize: 180
            },
            {
                header: intl.formatMessage({id: 'Sex'}),
                accessorKey: 'sex',
                filterFn: (row, id, filterValue) => {
                    return row.getValue(id) === filterValue;
                },
                enableColumnFilter: false,
            },
            {
                header: intl.formatMessage({id: 'Coat Color'}),
                accessorKey: 'coatColor',
                enableColumnFilter: false,
            },
            /* {
                 header: intl.formatMessage({id: 'Status'}),
                 accessorKey: intl.formatMessage({id: 'dogStatusType'}),
                 enableColumnFilter: false,
             },*/
            {
                header: intl.formatMessage({id: 'Sterilization Date'}),
                cell: ({row}) => (
                    <div className="text-center">{row.original.sterilizationDate}</div>
                ),
                filterFn: (row, id, filterValue) => {
                    return row.getValue(id) === filterValue;
                },
                enableColumnFilter: false,
            },
            {
                header: intl.formatMessage({id: 'Box'}),
                accessorKey: 'box.name',
                cell: ({row}) => (
                    <div className="text-center">{row.original.box?.name}</div>
                ),
                enableColumnFilter: true
            },
            {
                header: intl.formatMessage({id: "Shed"}),
                accessorKey: 'box.shedName',
                enableColumnFilter: true,
                cell: ({row}) => (
                    <div className="text-center">{row.original.box?.shedName}</div>
                )
            },
            {
                header: intl.formatMessage({id: 'Race'}),
                accessorKey: 'race',
                enableColumnFilter: false,
            },
            {
                header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
                enableColumnFilter: false,
                accessorKey: 'Actions',
                cell: ({row}) => {
                    const dog = row.original

                    // Funzione handlePrint corretta
                    const handlePrint = async () => {
                        try {
                            // Creare un componente PDF utilizzando i componenti di react-pdf

                            const YourDocument = () => (
                                <Document>
                                    <Page style={{
                                        padding: 30,
                                        fontFamily: 'Helvetica',
                                    }}>
                                     {/*   <View style={{
                                            backgroundColor: '#007bff',
                                            padding: 10,
                                            marginBottom: 20,
                                            borderRadius: 5,
                                        }}>
                                            <Text style={{
                                                color: 'white',
                                                fontSize: 18,
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}>
                                                Scheda Cane: {dog.name || 'N/A'}
                                            </Text>
                                        </View>*/}

                                        {dog.photoProfil && (
                                            <View style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                marginBottom: 15,
                                            }}>
                                                <Image
                                                    src={dog.photoProfil}
                                                    style={{
                                                        width: 150,

                                                        objectFit: 'contain',
                                                        marginBottom: 10,
                                                    }}
                                                />
                                            </View>
                                        )}

                                        {/* Informazioni generali */}
                                        <View style={{
                                            backgroundColor: 'white',
                                            borderRadius: 5,
                                            padding: 10,
                                            marginBottom: 15,
                                            border: '1pt solid #ddd',
                                        }}>
                                            <Text style={{
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                marginBottom: 10,
                                                paddingBottom: 5,
                                                borderBottom: '1pt solid #007bff',
                                            }}>
                                                Informazioni Generali
                                            </Text>

                                            <Text style={{fontSize: 12, marginBottom: 5}}>

                                                <Text style={{color: '#007bff'}}>Municipio di Provenienza: </Text>
                                                {dog.municipalityId || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Nome: </Text>
                                                {dog.name || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Microchip Code: </Text>
                                                {dog.microchipCode || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Data Cattura: </Text>
                                                {dog.catchingDate || 'N/A'}
                                            </Text>
                                          {/*  <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Stato Salute: </Text>
                                                {dog.catchingHealthStatus || 'N/A'}
                                            </Text>*/}
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Sterilizzato: </Text>
                                                {dog.isSterilizied ? "Sì" : "No"}
                                            </Text>
                                            {dog.isSterilizied && (
                                                <Text style={{fontSize: 12, marginBottom: 5}}>
                                                    <Text style={{color: '#007bff'}}>Data Sterilizzazione: </Text>
                                                    {dog.sterilizationDate || 'N/A'}
                                                </Text>
                                            )}
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Sesso: </Text>
                                                {dog.sex || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Razza: </Text>
                                                {dog.race || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Data di Nascita Presunta: </Text>
                                                {dog.bornDate || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Colore Mantello: </Text>
                                                {dog.coatColor || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Taglia: </Text>
                                                {dog.sizeDog || 'N/A'}
                                            </Text>
                                        </View>

                                        {/* Informazioni Box */}
                                        <View style={{
                                            backgroundColor: 'white',
                                            borderRadius: 5,
                                            padding: 10,
                                            marginBottom: 15,
                                            border: '1pt solid #ddd',
                                        }}>
                                            <Text style={{
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                marginBottom: 10,
                                                paddingBottom: 5,
                                                borderBottom: '1pt solid #007bff',
                                            }}>
                                                Informazioni Box
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Box di Appartenenza: </Text>
                                                {dog.box?.name || 'N/A'}
                                            </Text>
                                            <Text style={{fontSize: 12, marginBottom: 5}}>
                                                <Text style={{color: '#007bff'}}>Capannone: </Text>
                                                {dog.box?.shedName || 'N/A'}
                                            </Text>
                                        </View>

                                        {/* Trattamenti */}
                                        <View style={{
                                            backgroundColor: 'white',
                                            borderRadius: 5,
                                            padding: 10,
                                            marginBottom: 15,
                                            border: '1pt solid #ddd',
                                        }}>
                                            <Text style={{
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                marginBottom: 10,
                                                paddingBottom: 5,
                                                borderBottom: '1pt solid #007bff',
                                            }}>
                                                Trattamenti
                                            </Text>
                                            {dog.treatments && dog.treatments.length > 0 ? (
                                                dog.treatments.map((treatment, index) => (
                                                    <View key={index} style={{marginBottom: 10}}>
                                                        <Text style={{fontSize: 12, marginBottom: 2}}>
                                                            <Text style={{color: '#007bff'}}>Nota: </Text>
                                                            {treatment.notes || 'N/A'}
                                                        </Text>
                                                        <Text style={{ fontSize: 12, marginBottom: 2 }}>
                                                            <Text style={{ color: '#007bff' }}>Data: </Text>
                                                            {treatment.executionDate.toString()}
                                                        </Text>

                                                    </View>
                                                ))
                                            ) : (
                                                <Text style={{fontSize: 12}}>
                                                    Nessun trattamento per questo cane
                                                </Text>
                                            )}
                                        </View>
                                    </Page>
                                </Document>
                            );

                            const fileName = `${dog.microchipCode || 'dog'}_report.pdf`;
                            const blob = await pdf(<YourDocument/>).toBlob();

                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } catch (error) {
                            console.error("Errore nella generazione del PDF:", error);
                            dispatch(openSnackbar({
                                open: true,
                                message: intl.formatMessage({id: 'Errore nella generazione del PDF'}),
                                variant: 'alert',
                                alert: {
                                    color: 'error',
                                },
                            } as SnackbarState));
                        }
                    };

                    return (
                        <Stack direction="row" spacing={1}>
                            <Tooltip title="Edit">
                                <IconButton
                                    color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // Assicurati di passare il cane corrente (se ancora non caricato, gestisci il caso)
                                        // Ad esempio, potresti gestire un loading o mostrare un messaggio di attesa
                                        setSelectedElement(dog);
                                        setOpen(true);
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <IconButton
                                    color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedDeleteElement(dog);
                                        setDeleteAlertOpen(true);
                                    }}
                                >
                                    <Trash/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={<FormattedMessage id="View" defaultMessage="View"/>}>
                                <IconButton
                                    color="default"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedDog(row.original._id || undefined);
                                        setViewModalOpen(true);
                                    }}
                                >
                                    <Eye variant="Bold"/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={<FormattedMessage id="Download" defaultMessage="Download"/>}>
                                <IconButton
                                    color="default"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handlePrint();
                                    }}
                                >
                                    <DocumentDownload/>

                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                }
            }
        ]
    }, [selectedRows, elements, intl])


    // Fetch dei dati
    useEffect(() => {
        dispatch(getAllElement({
            pageableDto: {page: page, size: rowsPerPage, sort: ['dataCreated', 'desc']},
            filters: filters
        }))
        // console.log(selectedRows)
    }, [page, rowsPerPage, JSON.stringify(filters)])


    const handlePrintMunicipalityReport = async () => {
        try {
            setIsPrinting(true)

            const municipalityFilter = filters?.find(filter => filter.id === 'municipalityId')
            const municipalityValue = municipalityFilter ? String(municipalityFilter.value) : ''

            // Create a promise to wait for the data
            const dogsDataPromise = new Promise<DogElement[]>((resolve, reject) => {
                dispatch(getAllElementDogMuniNotPageable({
                    filters: municipalityValue,
                    callback: () => {
                        // Get the dogs data from the state after it's loaded
                        const dogsData = store.getState().DogElement.elements
                        setPrintData(dogsData)
                        resolve(dogsData)
                    }
                }))
            })

            const dogs = await dogsDataPromise

            // Rest of your print logic
            const MunicipalityReportDocument = () => (
                <Document>
                    <Page style={{
                        padding: 30,
                        fontFamily: 'Helvetica',
                    }}>
                        <View style={{
                            textAlign: 'center',
                            marginBottom: 20,
                        }}>
                            <Text style={{
                                fontSize: 18,
                                fontWeight: 'bold',
                            }}>
                                Report Cani per Comune: {municipalityValue}
                            </Text>
                            <Text>
                                Totale Cani: {dogs.length}
                            </Text>
                            <Text>
                                Generato il: {dayjs().format("DD/MM/YYYY")}
                            </Text>
                        </View>

                        {/* Dogs List */}
                        <View style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            gap: 10, // Reduced gap between boxes
                            justifyContent: 'space-between',
                        }}>
                            {dogs.map((dog, index) => (
                                <View key={index} style={{
                                    border: '1pt solid black',
                                    borderRadius: 8,
                                    padding: 8,  // Reduced padding for a tighter layout
                                    marginBottom: 15,
                                    width: '48%'  // Two items per row
                                }}>

                                    {/* Dog Info */}
                                    <View style={{marginBottom: 5}}>
                                        <Text style={{fontSize: 12}}>
                                            <Text style={{fontWeight: 'bold'}}>Microchip:</Text>
                                            {' '}{dog.microchipCode || 'N/A'}
                                        </Text>
                                    </View>

                                    <View style={{marginBottom: 5}}>
                                        <Text style={{fontSize: 12}}>
                                            <Text style={{fontWeight: 'bold'}}>Box/Cap:</Text>
                                            {' '}{dog.box?.name || 'N/A'} - {dog.box?.shedName || 'N/A'}
                                        </Text>
                                    </View>

                                </View>
                            ))}
                        </View>
                    </Page>
                </Document>

            )


            const fileName = `${municipalityValue || 'dog'}_report.pdf`;
            const blob = await pdf(<MunicipalityReportDocument/>).toBlob();

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch(getAllElement({
                pageableDto: {page, size: rowsPerPage, sort},
                filters: filters
            }))
            setIsPrinting(false)

        } catch (error) {
            console.error('Error generating municipality report:', error)
            dispatch(openSnackbar({
                open: true,
                message: intl.formatMessage({id: 'Error generating municipality report'}),
                variant: 'alert',
                alert: {
                    color: 'error',
                },
            } as SnackbarState))
        }
    }

const handlePrintSelectedDogsReport = async () => {
    try {
        setIsPrinting(true);

        // Creiamo una promise per attendere i dati
        const dogsDataPromise = new Promise<DogElement[]>((resolve, reject) => {
            dispatch(getListDog({
                filters: selectedRows,
                callback: () => {
                    // Otteniamo i dati dei cani dallo state dopo che sono stati caricati
                    const dogsData = store.getState().DogElement.elements;
                    setPrintData(dogsData);
                    resolve(dogsData);
                }
            }));
        });

        const dogs = await dogsDataPromise;

        // Define the document that will be generated
        const YourDocument = () => (
            <Document>
                {dogs.map((dog, index) => (
                    <Page key={index} style={{
                        padding: 30,
                        fontFamily: 'Helvetica',
                    }}>
                        {/* Photo */}
                        {dog.photoProfil && (
                            <View style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                marginBottom: 15,
                            }}>
                                <Image
                                    src={dog.photoProfil}
                                    style={{
                                        width: 150,
                                        objectFit: 'contain',
                                        marginBottom: 10,
                                    }}
                                />
                            </View>
                        )}

                        {/* Informazioni Generali */}
                        <View style={{
                            backgroundColor: 'white',
                            borderRadius: 5,
                            padding: 10,
                            marginBottom: 15,
                            border: '1pt solid #ddd',
                        }}>
                            <Text style={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                marginBottom: 10,
                                paddingBottom: 5,
                                borderBottom: '1pt solid #007bff',
                            }}>
                                Informazioni Generali
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Municipio di Provenienza: </Text>
                                {dog.municipalityId || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Nome: </Text>
                                {dog.name || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Microchip Code: </Text>
                                {dog.microchipCode || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Data Cattura: </Text>
                                {dog.catchingDate || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Stato Salute: </Text>
                                {dog.catchingHealthStatus || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Sterilizzato: </Text>
                                {dog.isSterilizied ? "Sì" : "No"}
                            </Text>
                            {dog.isSterilizied && (
                                <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                    <Text style={{ color: '#007bff' }}>Data Sterilizzazione: </Text>
                                    {dog.sterilizationDate || 'N/A'}
                                </Text>
                            )}
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Sesso: </Text>
                                {dog.sex || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Razza: </Text>
                                {dog.race || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Data di Nascita Presunta: </Text>
                                {dog.bornDate || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Colore Mantello: </Text>
                                {dog.coatColor || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Taglia: </Text>
                                {dog.sizeDog || 'N/A'}
                            </Text>
                        </View>

                        {/* Informazioni Box */}
                        <View style={{
                            backgroundColor: 'white',
                            borderRadius: 5,
                            padding: 10,
                            marginBottom: 15,
                            border: '1pt solid #ddd',
                        }}>
                            <Text style={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                marginBottom: 10,
                                paddingBottom: 5,
                                borderBottom: '1pt solid #007bff',
                            }}>
                                Informazioni Box
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Box di Appartenenza: </Text>
                                {dog.box?.name || 'N/A'}
                            </Text>
                            <Text style={{ fontSize: 12, marginBottom: 5 }}>
                                <Text style={{ color: '#007bff' }}>Capannone: </Text>
                                {dog.box?.shedName || 'N/A'}
                            </Text>
                        </View>

                        {/* Trattamenti */}
                        <View style={{
                            backgroundColor: 'white',
                            borderRadius: 5,
                            padding: 10,
                            marginBottom: 15,
                            border: '1pt solid #ddd',
                        }}>
                            <Text style={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                marginBottom: 10,
                                paddingBottom: 5,
                                borderBottom: '1pt solid #007bff',
                            }}>
                                Trattamenti
                            </Text>
                            {dog.treatments && dog.treatments.length > 0 ? (
                                dog.treatments.map((treatment, index) => (
                                    <View key={index} style={{ marginBottom: 10 }}>
                                        <Text style={{ fontSize: 12, marginBottom: 2 }}>
                                            <Text style={{ color: '#007bff' }}>Nota: </Text>
                                            {treatment.notes || 'N/A'}
                                        </Text>
                                        <Text style={{ fontSize: 12, marginBottom: 2 }}>
                                            <Text style={{ color: '#007bff' }}>Data: </Text>
                                            {treatment.executionDate.toString()}
                                        </Text>
                                    </View>
                                ))
                            ) : (
                                <Text style={{ fontSize: 12 }}>
                                    Nessun trattamento per questo cane
                                </Text>
                            )}
                        </View>
                    </Page>
                ))}
            </Document>
        );

        const fileName = `reports-multidog.pdf`;
        const blob = await pdf(<YourDocument />).toBlob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setIsPrinting(false);
        dispatch(getAllElement({
            pageableDto: { page, size: rowsPerPage, sort },
            filters: filters
        }));

    } catch (error) {
        console.error('Error generating report:', error);
        // Handle error (snackbar, ecc.)
    }
};

    // Funzioni di gestione della paginazione
    const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen)
        if (!isOpen) setSelectedElement(null)
    }

    const columnFiltersState = (values: ColumnFiltersState) => {
        setFilters(values)
        setPage(0) // Reset della pagina quando cambia il filtro
    }

    // Gestione eliminazione
    const onDeleteSuccess = () => {
        dispatch(getAllElement({pageableDto: {page: currentPage, size: rowsPerPage, sort}, filters: filters}))
        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    }

    const onUpdateBoxSuccess = () => {
        //    console.log("log 5")
        dispatch(getAllElement({pageableDto: {page: currentPage, size: rowsPerPage, sort}, filters: filters}))
        openSnackbar({
            open: true,
            message: intl.formatMessage({id: 'Box updated successfully for selected dogs.'}),
            variant: 'alert',
            alert: {
                color: 'success'
            }
        } as SnackbarState)

    }

    const handleFormSuccess = () => {
        setIsSubmitting(false)
        refreshData()
        setOpen(false)
    }

    const handleFormError = (error: any) => {
        setIsSubmitting(false)
        // Show error message
    }
    const handleDeselectAll = () => {
        setSelectedRows([]) // Resetta lo stato delle righe selezionate
    }


    const handleDelete = (id: string) => dispatch(deleteElement({id, callback: onDeleteSuccess}))


    const changeBox = (idBox: string | null, selectedDogs: string[]) => {
        dispatch(updateElementBoxDogs({
            idBox: idBox,
            dogIds: selectedDogs,
            callback: onUpdateBoxSuccess
        }))
    }


    //const handleRefresh = (id: string) => dispatch(deleteElement({id, callback: refreshDataWithFilters}))

    const refreshData = () => {
        dispatch(getAllElement({
            pageableDto: {
                page: page,
                size: rowsPerPage,
                sort: ['dateCreated', 'desc']
            },
            filters: filters
        }))

        openSnackbar({
            open: true,
            message: intl.formatMessage({id: 'Dog Added complete'}),
            variant: 'alert',
            alert: {
                color: 'success'
            }
        } as SnackbarState)
    }

    return (
        <>
            <CustomLoader
                open={loading || isPrinting || isSubmitting}
                message={isSubmitting ? "Saving..." : "Loading..."}
            />


            <Grid container>
                <Grid item xs={12}>
                    <BasicTableForDog
                        columns={columns}
                        data={paginatedElements}
                        title={intl.formatMessage({
                            id: "DogTitle" + totalRows,
                            defaultMessage: "Cani presenti nel canile: " + totalRows
                        })}
                        striped
                        modalToggler={() => handleModalOpen(!open)}
                        modalBox={() => setChangeBoxModalOpen(!open)}
                        openModalViews={() => handleModalOpen(!open)}
                        selectedRows={selectedRows}
                        onPrintMunicipalityReport={handlePrintMunicipalityReport}
                        onFilterChange={columnFiltersState}
                        manualFiltering={true}
                        onDeselectAll={handleDeselectAll}
                        onPrintSelectedDog={handlePrintSelectedDogsReport}
                    />
                    <ElementModalGeneric
                        open={open}
                        setOpen={handleModalOpen}
                        element={selectedElement}
                        FormComponent={DogElementForm}
                        onSuccess={refreshData}
                        pageableData={{
                            page,
                            rowsPerPage,
                            filters
                        }}
                    />

                    <ViewDogModal
                        open={viewModalOpen}
                        onClose={() => setViewModalOpen(false)}
                        dogData={selectedDog}
                        pageableData={{
                            page,
                            rowsPerPage,
                            filters
                        }}
                        // onSuccess={() => handleRefresh}
                    />
                    <TablePagination
                        component="div"
                        count={totalRows}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <ModalChangeBox
                        id={selectedElement?._id || ""}
                        title={selectedElement?.name || ""}
                        open={changeBoxModalOpen}
                        handleClose={() => setChangeBoxModalOpen(false)}
                        dateDogs={selectedRows}
                        onEnter={(selectedRows, selectedBoxId) => changeBox(selectedBoxId, selectedRows)}
                        onDeselectAll={handleDeselectAll}
                    />

                    {selectedDeleteElement && (
                        <AlertExampleElementDelete
                            id={selectedDeleteElement._id}
                            title={selectedDeleteElement.name}
                            open={deleteAlertOpen}
                            handleClose={() => setDeleteAlertOpen(false)}
                            onDelete={(id) => handleDelete(id)}
                        />
                    )}
                </Grid>
            </Grid>
        </>
    )
}